import './styles.scss'

export default function NotifyInfo() {
    return (
        <div className="notification-info-alert">
            <div className="notification-info-alert-icon">
                <em className="fas fa-exclamation" />
            </div>
            <div className='notification-info-alert-text'>
                <p>Los datos del contratante deben ser de una persona mayor de edad.</p>
            </div>
        </div>
    )
}